import { createFileRoute, Link } from "@tanstack/react-router";
import { DemoSection } from "@/components/ui/demo/DemoSection";
import { transitions } from "@/styles/transitions";

export const Route = createFileRoute("/demo/tests/")({
  component: TestsOverview,
});

function TestsOverview() {
  const testTools = [
    {
      description:
        "Test page for measuring and validating component dimensions across different screen sizes and viewport configurations.",
      features: ["Size validation", "Responsive testing", "Visual debugging"],
      id: "component-size-test",
      path: "/demo/tests/component-size-test",
      title: "Component Size Test",
    },
  ];

  return (
    <DemoSection
      description="Tools and test pages for debugging and validating components, ensuring consistent behavior across different environments."
      title="Test & Debug Tools"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {testTools.map((tool) => (
          <Link
            className={`block p-4 bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 hover:border-theme-primary dark:hover:border-theme-primary ${transitions.colors}`}
            key={tool.id}
            to={tool.path}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {tool.title}
              </h3>
              <div className="flex items-center">
                <span className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 rounded-full px-2 py-0.5 mr-2">
                  Test Page
                </span>
                <svg
                  aria-hidden="true"
                  className="h-5 w-5 text-theme-primary"
                  fill="currentColor"
                  role="img"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>View Test Tool</title>
                  <path
                    clipRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {tool.description}
            </p>

            {/* Features list */}
            <div className="mt-3 flex items-center text-xs">
              <svg
                aria-hidden="true"
                className="h-4 w-4 text-gray-400 mr-1"
                fill="currentColor"
                role="img"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Test Capabilities</title>
                <path
                  clipRule="evenodd"
                  d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  fillRule="evenodd"
                />
              </svg>
              <span className="text-gray-500 dark:text-gray-400">
                {tool.features.join(" • ")}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </DemoSection>
  );
}
